import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTranscriptionBadAccoustics = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 417,
	height: 309,
	viewBox: "0 0 417 309",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_11326_273633)",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				opacity: .2,
				children: [
					/* @__PURE__ */ _jsxs("g", {
						opacity: .5,
						children: [/* @__PURE__ */ _jsx("path", {
							d: "M182.19 108.24C186.792 108.24 190.523 111.971 190.523 116.574V185.323C190.523 189.925 186.792 193.656 182.19 193.656C177.588 193.656 173.857 189.925 173.857 185.323V116.574C173.857 111.971 177.588 108.24 182.19 108.24Z",
							fill: "#3086EE"
						}), /* @__PURE__ */ _jsx("path", {
							d: "M248.857 108.24C244.254 108.24 240.523 111.971 240.523 116.574V185.323C240.523 189.925 244.254 193.656 248.857 193.656C253.459 193.656 257.19 189.925 257.19 185.323V116.574C257.19 111.971 253.459 108.24 248.857 108.24Z",
							fill: "#3086EE"
						})]
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M207.191 96.935C207.191 92.3327 210.922 88.6017 215.524 88.6017C220.127 88.6017 223.858 92.3327 223.858 96.935V204.96C223.858 209.563 220.127 213.294 215.524 213.294C210.922 213.294 207.191 209.563 207.191 204.96V96.935Z",
						fill: "#3086EE"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M273.857 137.927C273.857 133.325 277.588 129.594 282.19 129.594C286.792 129.594 290.523 133.325 290.523 137.927V163.969C290.523 168.571 286.792 172.302 282.19 172.302C277.588 172.302 273.857 168.571 273.857 163.969V137.927Z",
						fill: "#3086EE"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M148.857 129.594C153.459 129.594 157.19 133.325 157.19 137.927V163.969C157.19 168.571 153.459 172.302 148.857 172.302C144.254 172.302 140.523 168.571 140.523 163.969V137.927C140.523 133.325 144.254 129.594 148.857 129.594Z",
						fill: "#3086EE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				filter: "url(#filter0_d_11326_273633)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M367.173 192.807C362.171 174.136 342.979 163.055 324.307 168.058C305.636 173.061 294.556 192.253 299.559 210.924C304.562 229.596 323.753 240.676 342.425 235.673C361.096 230.67 372.176 211.478 367.173 192.807Z",
						fill: "url(#paint0_linear_11326_273633)",
						fillOpacity: .6
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M366.689 192.937C361.758 174.532 342.84 163.61 324.436 168.542C306.031 173.473 295.109 192.391 300.041 210.795C304.972 229.2 323.89 240.122 342.294 235.191C360.699 230.259 371.621 211.341 366.689 192.937Z",
						stroke: "url(#paint1_linear_11326_273633)",
						strokeOpacity: .5
					}),
					/* @__PURE__ */ _jsx("path", {
						opacity: .5,
						d: "M336.709 194.195L340.097 206.839C340.731 209.209 340.353 211.214 339.053 212.478C338.526 212.988 337.881 213.338 337.165 213.53C336.063 213.825 334.779 213.771 333.364 213.338L328.667 211.895C328.347 211.804 328.004 211.792 327.688 211.877L324.437 212.748L320.193 196.908L323.443 196.037C323.76 195.952 324.051 195.771 324.282 195.532L327.629 191.934C329.304 190.141 331.215 189.393 332.986 189.834C334.744 190.278 336.074 191.826 336.709 194.195Z",
						fill: "#3086EE"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M320.195 196.908L324.439 212.748L323.751 212.932C320.418 213.826 318.095 212.485 317.202 209.151L315.725 203.642C314.832 200.309 316.173 197.986 319.507 197.093L320.195 196.908Z",
						fill: "#3086EE"
					}),
					/* @__PURE__ */ _jsx("path", {
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M342.221 194.047C343.132 195.572 343.83 197.218 344.291 198.94C344.753 200.663 344.972 202.437 344.945 204.213C344.93 205.179 344.135 205.951 343.169 205.936C342.202 205.922 341.431 205.126 341.445 204.16C341.467 202.707 341.288 201.255 340.91 199.846C340.533 198.437 339.962 197.09 339.217 195.843C338.721 195.013 338.991 193.939 339.821 193.443C340.651 192.947 341.725 193.218 342.221 194.047Z",
						fill: "#3086EE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				filter: "url(#filter1_d_11326_273633)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M108.22 132.978C103.932 116.974 87.4818 107.476 71.4778 111.764C55.4738 116.053 45.9763 132.503 50.2646 148.507C54.5528 164.511 71.0029 174.008 87.0069 169.72C103.011 165.432 112.508 148.982 108.22 132.978Z",
						fill: "url(#paint2_linear_11326_273633)",
						fillOpacity: .6
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M107.738 133.108C103.521 117.37 87.3453 108.031 71.6081 112.248C55.8708 116.465 46.5317 132.641 50.7484 148.378C54.9652 164.115 71.1412 173.454 86.8784 169.238C102.616 165.021 111.955 148.845 107.738 133.108Z",
						stroke: "url(#paint3_linear_11326_273633)",
						strokeOpacity: .5
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M88.2752 150.403L81.2877 148.378L76.2454 153.611C75.3228 154.573 73.7114 153.949 73.6673 152.625L73.4287 145.359L66.8767 142.176C65.6808 141.596 65.7753 139.863 67.0232 139.42L73.862 136.95L74.8729 129.769C75.0511 128.464 76.7318 128.013 77.5389 129.055L82.0087 134.783L89.166 133.502C90.4683 133.262 91.4169 134.716 90.6713 135.816L86.5885 141.849L90.0147 148.26C90.6384 149.429 89.5548 150.775 88.2752 150.403Z",
						fill: "#3086EE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				filter: "url(#filter2_d_11326_273633)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M308.13 75.1753C312.312 59.1434 302.707 42.7562 286.675 38.5735C270.643 34.3908 254.256 43.9964 250.073 60.0283C245.89 76.0602 255.496 92.4474 271.528 96.6301C287.56 100.813 303.947 91.2072 308.13 75.1753Z",
						fill: "url(#paint4_linear_11326_273633)",
						fillOpacity: .6
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M307.648 75.049C311.761 59.2843 302.315 43.1702 286.55 39.0572C270.786 34.9442 254.672 44.3898 250.559 60.1545C246.446 75.9192 255.891 92.0332 271.656 96.1462C287.421 100.259 303.535 90.8137 307.648 75.049Z",
						stroke: "url(#paint5_linear_11326_273633)",
						strokeOpacity: .5
					}),
					/* @__PURE__ */ _jsx("path", {
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M281.752 57.4419C276.14 55.978 270.405 59.3399 268.941 64.9511C267.477 70.5623 270.839 76.2978 276.45 77.7617C282.061 79.2257 287.797 75.8637 289.261 70.2525C290.725 64.6414 287.363 58.9059 281.752 57.4419ZM282.509 54.5391C275.295 52.6569 267.92 56.9794 266.038 64.1937C264.156 71.4081 268.478 78.7823 275.693 80.6646C282.907 82.5468 290.281 78.2242 292.164 71.0099C294.046 63.7955 289.723 56.4213 282.509 54.5391Z",
						fill: "#3086EE"
					}),
					/* @__PURE__ */ _jsxs("g", {
						opacity: .5,
						children: [/* @__PURE__ */ _jsx("path", {
							d: "M277.301 68.7789C277.091 69.5805 277.572 70.3999 278.373 70.609C279.175 70.8182 279.994 70.3379 280.203 69.5363L282.213 61.8324C282.422 61.0308 281.942 60.2114 281.141 60.0023C280.339 59.7931 279.52 60.2734 279.31 61.075L277.301 68.7789Z",
							fill: "#3086EE"
						}), /* @__PURE__ */ _jsx("path", {
							d: "M276.096 73.3987C275.887 74.2003 276.367 75.0196 277.169 75.2288C277.971 75.4379 278.79 74.9576 278.999 74.156L279.077 73.8589C279.286 73.0573 278.805 72.238 278.004 72.0288C277.202 71.8197 276.383 72.3 276.174 73.1016L276.096 73.3987Z",
							fill: "#3086EE"
						})]
					})
				]
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_11326_273633",
			x: 250.355,
			y: 142.857,
			width: 166.02,
			height: 166.018,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 24 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 24 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_11326_273633"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_11326_273633",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter1_d_11326_273633",
			x: 1.23438,
			y: 86.7349,
			width: 156.016,
			height: 156.015,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 24 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 24 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_11326_273633"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_11326_273633",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter2_d_11326_273633",
			x: 201.094,
			y: 13.5945,
			width: 156.018,
			height: 156.015,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 24 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 24 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_11326_273633"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_11326_273633",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_11326_273633",
			x1: 324.307,
			y1: 168.058,
			x2: 342.425,
			y2: 235.673,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#C9C9C9",
				stopOpacity: .5
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#EAEBF0",
				stopOpacity: .5
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_11326_273633",
			x1: 324.236,
			y1: 168.229,
			x2: 342.353,
			y2: 235.844,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#CACCD8" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#6B6C72",
				stopOpacity: .25
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint2_linear_11326_273633",
			x1: 71.4778,
			y1: 111.764,
			x2: 87.0069,
			y2: 169.72,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#C9C9C9",
				stopOpacity: .5
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#EAEBF0",
				stopOpacity: .5
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint3_linear_11326_273633",
			x1: 71.4079,
			y1: 111.935,
			x2: 86.937,
			y2: 169.891,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#CACCD8" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#6B6C72",
				stopOpacity: .25
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint4_linear_11326_273633",
			x1: 286.675,
			y1: 38.5735,
			x2: 271.528,
			y2: 96.6301,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#C9C9C9",
				stopOpacity: .5
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#EAEBF0",
				stopOpacity: .5
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint5_linear_11326_273633",
			x1: 286.842,
			y1: 38.5028,
			x2: 271.695,
			y2: 96.5595,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#CACCD8" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#6B6C72",
				stopOpacity: .25
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_11326_273633",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 416,
				height: 309,
				fill: "white",
				transform: "translate(0.5)"
			})
		})
	] })]
});
export default SvgTranscriptionBadAccoustics;
